import { inject } from '@angular/core';
import { StoreSettingsService } from 'src/app/demo/dashboard/settings/store-settings/store-settings.service';

export function getBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

export function resolveTimezone(settingsSvc: StoreSettingsService): Promise<string> {
  const browser = getBrowserTimezone();
  if (browser) return Promise.resolve(browser);
  return new Promise(resolve => {
    settingsSvc.get().subscribe({
      next: (res) => resolve(res?.data?.systemTimezone || 'UTC'),
      error: () => resolve('UTC'),
    });
  });
}
